import React, { useContext } from "react";
import axios from "axios";
import FormCard from "../../components/Cards/FormCard/FormCard";

import "./userReservations.scss";
import "../../components/Cards/FormCard/formCard.scss";
import { Link } from "react-router-dom";
import { CurrentUserContext } from "context/UserContext";

const UserReservations = () => {
  const [user] = useContext(CurrentUserContext);

  //RESERVATIONS
  const [reservations, setReservations] = React.useState(null);

  //API RESERVATIONS
  React.useEffect(() => {
    const fetchReservationsResult = async () => {
      try {
        const resultado = await axios(
          `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/reservations/user/${user.id}`,
          { headers: { Authorization: `Bearer ${user.jwt}` } }
        );
        setReservations(resultado.data);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchReservationsResult();
  }, [user]);

  return reservations ? (
    <div className="resultPage__container">
      {reservations.length === 0 ? (
        <p className="emptyResults">
          Este usuario no tiene reservas.{" "}
          <Link to="/home" style={{ color: "#f0572d" }}>
            Volver al home
          </Link>
        </p>
      ) : (
        <section className="reservationCards">
          <h2>Vehículos reservados</h2>
          <div className="reservationCards__container">
            {reservations.map((reservation) => (
              <div className="results__container__card" key={reservation.id}>
                <FormCard
                  noSubmitButton
                  product={reservation.product}
                  dates={{
                    check_in: reservation.start_date
                      .slice(0, 10)
                      .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3/$2/$1"),
                    check_out: reservation.end_date
                      .slice(0, 10)
                      .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3/$2/$1"),
                    withdrawal_time: reservation.start_time?.slice(0, 5),
                  }}
                />
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  ) : (
    <div className="resultPage__container">
      <h2 className="product__loading">Loading data...</h2>/
    </div>
  );
};

export default UserReservations;
